import { useState } from 'react'

import {
  brokerageIconFallbackSrc,
  brokerageIconPlaceholderSrc,
  brokerageIconSrc,
} from '@/config/marketing-assets.config'
import { cn } from '@/lib/utils'

function brokerageInitials(name: string) {
  return name
    .split(/\s+/)
    .map((word) => word[0])
    .join('')
    .slice(0, 2)
    .toUpperCase()
}

export function BrokerageIcon({
  slug,
  name,
  iconSlug,
  className,
  size = 32,
}: {
  slug: string
  name: string
  iconSlug?: string
  className?: string
  size?: number
}) {
  const [src, setSrc] = useState(() => brokerageIconSrc(slug, iconSlug))
  const [showInitials, setShowInitials] = useState(false)

  if (showInitials) {
    return (
      <span
        className={cn('brokerage-icon brokerage-icon--placeholder', className)}
        // Inline style is intentional: size is a runtime numeric prop, not a
        // design-token value, so it can't be a static Tailwind/utility class.
        style={{ width: size, height: size }}
        aria-hidden
      >
        {brokerageInitials(name)}
      </span>
    )
  }

  return (
    <span className={cn('brokerage-icon', className)} style={{ width: size, height: size }}>
      <img
        src={src}
        alt=""
        width={size}
        height={size}
        loading="lazy"
        decoding="async"
        onError={() => {
          const fallback = brokerageIconFallbackSrc(slug, iconSlug)
          const placeholder = brokerageIconPlaceholderSrc()
          if (src.endsWith('.webp')) {
            setSrc(fallback)
            return
          }
          if (src.endsWith('.svg') && src !== placeholder) {
            setSrc(placeholder)
            return
          }
          setShowInitials(true)
        }}
      />
    </span>
  )
}
